<template>
  <div class="timetable">

    <!-- 表头 -->
    <div class="header-row" :style="{ height: rowHeight -2 + 'px', fontSize: fontSize + 'px' }">
      <!-- 场次列 -->
      <div class="header-cell scene-cell" style="margin-right: 10px">
        <div class="header-inner">
          <fontStyle
              text="场次"
              :width="sceneColWidth"
              :height="rowHeight + 10"
              :fontSize="fontSize"
              :bgImageUrl="require('@/assets/itemHeaderBk2.png')"
              :strokeWidth="10"
              :rowNumber="config.themeSort"
              fillColor="#35E3EF"
          />
        </div>
      </div>

      <!-- 动态主题列 -->
      <div
          v-for="(col, index) in columns"
          :key="index"
          class="header-cell content-cell"
          :style="{ width: contentColWidth + 'px' }"
      >
        <div class="header-inner">
          <fontStyle
              :text="col.themeName"
              :width="paddingContentColWidth"
              :height="rowHeight + 20"
              :fontSize="fontSize"
              :strokeWidth="10"
              fillColor=""
              :rowNumber="config.themeSort"
              :bgImageUrl="require('@/assets/itemHeaderBk1.png')"
          />
        </div>
      </div>
    </div>

    <!-- 甘特图内容区域 -->
    <div class="gantt-content" :style="{ height: contentHeight + 'px' }">
      <!-- 时间轴 -->
      <div class="time-axis">
        <div
            v-for="(time, index) in visibleTimeSlots"
            :key="index"
            class="time-slot"
            :style="{ height: rowHeight + 'px' }"
        >
          <div class="time-label">{{ time }}</div>
          <div class="circle-outer">
            <div class="circle-inner"></div>
          </div>
        </div>
      </div>

      <!-- 主题内容区域 -->
      <div class="themes-container">
        <div
            v-for="(col, cIndex) in columns"
            :key="cIndex"
            class="theme-column"
            :style="{ width: contentColWidth + 'px' }"
        >
          <!-- 背景时间网格 -->
          <div class="time-grid">
            <div
                v-for="(time, index) in visibleTimeSlots"
                :key="index"
                class="grid-line"
                :style="{ height: rowHeight + 'px' }"
            ></div>
          </div>

          <!-- 活动块  -->
          <newItem
              v-for="(session, sIndex) in col.sessionList"
              :key="session.startTimeStr + '-' + session.endTimeStr + '-' + sIndex"
              :session="formatSession(session)"
              :width="paddingContentColWidth"
          />
        </div>
      </div>
    </div>
    <div class="timetable-error" v-if="isShowError">
      {{errorText}}
    </div>
    <!-- 分屏按钮 -->
    <!--    <div style="position:absolute; bottom:10px; left:50%; transform:translateX(-50%);z-index: 99">-->
    <!--      <button @click="prevScreen" :disabled="currScreen === 0">上一屏</button>-->
    <!--      <button @click="nextScreen" :disabled="currScreen === totalScreens - 1">下一屏</button>-->
    <!--      <span>第 {{ currScreen + 1 }} / {{ totalScreens }} 屏</span>-->
    <!--    </div>-->

    <div class="zhichi">极迅科技提供技术支持</div>

  </div>
</template>

<script>
import fontStyle from "./fontStyle.vue";
import newItem from "./newItem.vue";
import dayjs from 'dayjs';

export default {
  name: "TimeTable",
  components: {fontStyle, newItem},
  data() {
    return {
      config: {
        interval: 3, // 数据轮询间隔 / 自动翻屏间隔（单位：秒）
        themeSort: 4, // 每一屏显示的主题数量
      },
      columns: [],       // 当前页显示的主题数据
      allColumns: [],    // 所有主题数据
      timeSlots: [],     // 时间段集合
      timeList: [],      // 全部时间点
      visibleTimeSlots: [], // 当前屏幕可见时间点字符串列表
      // 样式参数
      rowHeight: 40,
      fontSize: 14,
      rowsPerScreen: 11,         // 一屏显示多少行时间
      slotMinutes: 30,           // 每格时间间隔
      sceneColWidth: 120,        // 场次列宽度
      contentColWidth: 100,      // 内容列宽度
      paddingContentColWidth: 80,// 内容列内宽度
      contentHeight: 440,        // 内容总高度

      // 分屏控制
      currScreen: 0,             // 当前屏幕页码
      totalScreens: 0,           // 总页数

      // 轮询控制
      pollTimer: null,
      pollRunning: false,
      pollRetryCount: 0,
      pollMaxRetry: 10,           // 连续异常停止轮询的次数上限
      isShowError: false, //唤起异常弹窗
      errorText:'投屏异常“请重新插拔视频盒子网线或者重启”', //异常信息
      defaultErrorText: '投屏异常“请重新插拔视频盒子网线或者重启”',
      uuid: '',
    };
  },

  mounted() {
    this.setTime();
    this.calcLayout();

    // this.fetchThemeData()
    window.addEventListener("resize", this.calcLayout);
    this.startPolling();     // 后台轮询更新数据


  },
  beforeUnmount() {
    window.removeEventListener("resize", this.calcLayout);
    this.stopPolling();
    this.stopAutoScreen();
  },
  methods: {
    // 启动轮询
    startPolling() {
      if (this.pollRunning) return;
      this.pollRunning = true;
      this.pollRetryCount = 0;
      this._poll();
    },

    // 停止轮询
    stopPolling() {
      this.pollRunning = false;
      if (this.pollTimer) clearTimeout(this.pollTimer);
    },

    // 执行轮询任务
    async _poll() {
      if (!this.pollRunning) return;
      try {
      const result = await this.fetchThemeData(); // 拉取主题数据
        this.pollRetryCount = 0;
      } catch (err) {
        this.pollRetryCount++;
        // 连续错误达到上限时停止轮询
        if (this.pollRetryCount >= this.pollMaxRetry) {
          // this.columns = [];
          // this.allColumns = []
          // this.visibleTimeSlots = []
          let data = {
            error: err,
            uuid: this.getUUIDFromCurrentUrl() || `没有在url上读取到uuid 完整链接${window.location.hash}`
          }
          this.$ERROR('customer/log/error', {bizName: 'ERROR_SPL_CCTP_MAXERROR', fields: JSON.stringify(data)})
          this.isShowError = true
          this.stopPolling();
          return;
        }
      }
      // 按间隔继续轮询
      if (this.pollRunning) {
        this.pollTimer = setTimeout(() => this._poll(), this.config.interval * 1000);
        this.startAutoScreen();  // 自动翻页
      }
    },

    // 启动自动翻页
    startAutoScreen() {
      this.stopAutoScreen(); // 先停止旧定时器
      this.autoScreenTimer = setInterval(() => {
        // 翻页逻辑：循环显示
        if (this.currScreen < this.totalScreens - 1) {
          this.currScreen++;
        } else {
          this.currScreen = 0;
        }
        this.updateColumnsByScreen();
      }, this.config.interval * 1000);
    },

    // 停止自动翻页
    stopAutoScreen() {
      if (this.autoScreenTimer) {
        clearTimeout(this.autoScreenTimer);
        this.autoScreenTimer = null;
      }
    },

    // 下一页按钮操作
    nextScreen() {
      if (this.currScreen >= this.totalScreens - 1) {
        this.currScreen = 0;
      } else {
        this.currScreen++;
      }
      this.updateColumnsByScreen();
    },

    // 上一页按钮操作
    prevScreen() {
      if (this.currScreen > 0) {
        this.currScreen--;
      } else {
        this.currScreen = this.totalScreens - 1;
      }
      this.updateColumnsByScreen();
    },

    // 按当前页更新主题列
    updateColumnsByScreen() {
      if (!this.allColumns || !this.allColumns.length) {
        this.columns = [];
        return;
      }
      const start = this.currScreen * this.config.themeSort;
      const end = start + this.config.themeSort;
      this.columns = this.allColumns.slice(start, end);
      this.setTime()
      this.$nextTick(() => this.calcLayout());
    },

    calcLayout() {
      this.$nextTick(() => {
        const screenHeight = window.innerHeight;
        const screenWidth = window.innerWidth;

        // 行高、字体大小
        this.rowHeight = Math.floor(screenHeight / this.rowsPerScreen);
        this.fontSize = Math.max(12, Math.floor(this.rowHeight * 0.4));
        this.contentHeight = this.rowHeight * this.rowsPerScreen;

        // 动态计算每个主题列宽度
        const themeCount = this.config.themeSort || 1;
        const baseGap = 20;
        const dynamicGap = Math.min(baseGap, Math.floor(baseGap / themeCount));
        this.contentColWidth = Math.floor((screenWidth - this.sceneColWidth) / themeCount - dynamicGap);
        this.paddingContentColWidth = this.contentColWidth - 20;
      });
    },


    notifyAndroidThemeDataLoaded(extra = {}) {
      const message = JSON.stringify({
        type: 'fetchThemeDataSuccess',
        uuid: this.getUUIDFromCurrentUrl(),
        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        ...extra,
      });
      window.setTimeout(() => {
        try {
          if (window.AndroidBridge && window.AndroidBridge.showMessage) {
            window.AndroidBridge.showMessage(message);
          }
        } catch (error) {
          console.error('调用 AndroidBridge 失败:', error);
        }
      }, 0);

    },

    notifyAndroidThemeDataError(extra = {}) {
      const message = JSON.stringify({
        type: 'fetchThemeDataError',
        uuid: this.getUUIDFromCurrentUrl(),
        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        ...extra,
      });
      window.setTimeout(() => {
        try {
          if (window.AndroidBridge && window.AndroidBridge.showMessage) {
            window.AndroidBridge.showMessage(message);
          }
        } catch (error) {
          console.error('调用 AndroidBridge 失败:', error);
        }
      }, 0);
    },

    getDisplayScreenErrorInfo(error) {
      const code = error && error.code !== undefined && error.code !== null ? Number(error.code) : '';
      const msg = error && (error.msg || error.message) ? (error.msg || error.message) : '';
      return {code, msg};
    },

    async fetchThemeData(resetCurrScreen = false) {
      // 构建接口参数
      let param = {
        orderType: 1,
        uuid: this.getUUIDFromCurrentUrl(),
        sessionStartDateTime: this.$dayjs(this.timeList[0].time).format('YYYY-MM-DD HH:mm:ss'),
        sessionEndDateTime: this.$dayjs(this.timeList[this.timeList.length - 1].time).add(30, 'minute').format('YYYY-MM-DD HH:mm:ss'),
      };
      try {
      // 拉取主题数据
      const query = Object.keys(param)
      .map(key => {
        const value = param[key] == null ? '' : param[key];
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
      })
      .join('&');
      let url = "/customer/EomsApp/box/theme/show?" + query;
      const res = await this.$GET(url, false, "loading...", false);

      // const res = await this.$POST("/customer/EomsApp/box/theme/show", param, false, "loading...", false);
      const baseTime = this.timeList[0].time;
      const allThemes = [];
      let boxJson = JSON.parse(res.data.boxJson);
      this.isShowError = false;
      // 更新配置
      this.config = {...boxJson};
      res.data.deviceBoxes.forEach(theme => {
        const sessionList = [];
        // 遍历每场次
        theme.themeSessionList.forEach((session, j) => {
          let today = this.$dayjs().format("YYYY-MM-DD");
          if (this.$dayjs(session.startTime).isAfter(session.endTime)) {
            today = this.$dayjs().add(1, "day").format("YYYY-MM-DD");
          }
          const start = this.$dayjs(today + " " + session.startTime);
          const end = this.$dayjs(today + " " + session.endTime);

          if (end.isAfter(baseTime)) {
            // 将时间差转换为像素长度
            const mpx = this.$tools.accDiv(this.rowHeight, 30);
            const len = this.$tools.accMul(end.diff(start, "minute"), mpx);
            let top = 0;

            // 计算每个活动块的纵向位置
            if (baseTime.isAfter(start)) top = this.$tools.accMul(baseTime.diff(start, "minute"), mpx) * -1;
            else top = this.$tools.accMul(start.diff(baseTime, "minute"), mpx);

            // 构建 session 数据结构
            let sessionData = {
              ...session,
              startTimeStr: start.format("HH:mm"),
              endTimeStr: end.format("HH:mm"),
              playerMax: theme.playerCountMax || 8,
              top: top,
              len: len,
              gameState: 0,
              peopleNum: 0,
              isIntersect: false,
              sessionDay: today,
              tags: 0,
            };
            // 关联订单数据，更新场次状态
            if (theme.orderList) {
              theme.orderList.forEach(order => {
                if (order.sessionStartTime == session.startTime && order.sessionEndTime == session.endTime) {
                  sessionData.gameState = order.gameState;
                  sessionData.peopleNum = order.peopleNum;
                  sessionData.tags = order.tags;
                }
              });
            }

            // 根据实时状态修正
            if (this.$dayjs().isAfter(start) && sessionData.peopleNum < sessionData.playerMax && sessionData.gameState === 0 && sessionData.tags === 0) {
              sessionData.gameState = -1;
            }

            // 判断场次是否连续（滚场）
            if (theme.themeSessionList[j + 1] && session.endTime == theme.themeSessionList[j + 1].startTime) {
              sessionData.isIntersect = true;
            }

            sessionList.push(sessionData);
          }
        });

        // 检查是否滚场主题
        const rolling = this.isRollingGround(sessionList);
        if (rolling) {
          boxJson.selectTheme.forEach((selectedTheme, index) => {
            if (`${theme.themeId}A` == selectedTheme) {
              allThemes.push({themeName: theme.themeName + "A", sessionList: rolling.sessionListA});
            }
            if (`${theme.themeId}B` == selectedTheme) {
              allThemes.push({themeName: theme.themeName + "B", sessionList: rolling.sessionListB});
            }
          })
        } else {
          boxJson.selectTheme.forEach((selectedTheme) => {
            if (`${theme.themeId}` == `${selectedTheme}`) {
              allThemes.push({themeName: theme.themeName, sessionList});
            }
          })
        }
      });
      // 保存所有主题数据并刷新当前页
      this.allColumns = allThemes;
      this.totalScreens = Math.ceil(this.allColumns.length / this.config.themeSort);
      if (resetCurrScreen) {
        this.currScreen = 0;
      } else if (this.currScreen >= this.totalScreens) {
        this.currScreen = this.totalScreens - 1;
      }
      this.updateColumnsByScreen();
      this.notifyAndroidThemeDataLoaded({
        themeCount: this.allColumns.length,
        totalScreens: this.totalScreens,
      });
      } catch (e) {
        const errorInfo = this.getDisplayScreenErrorInfo(e);
        this.columns = [];
        this.allColumns = []
        this.visibleTimeSlots = []
        if (errorInfo.code === 5200) {
          this.errorText = errorInfo.msg || this.defaultErrorText;
          this.isShowError = true;
          this.notifyAndroidThemeDataError(errorInfo);
          return {
            keepPolling: true,
            ...errorInfo,
          };
        }
        this.errorText = this.defaultErrorText;
        this.isShowError = false;
        throw e;
      }
    },

    /* 判断是否滚场主题 */
    isRollingGround(sessionList) {
      if (sessionList[0] && sessionList[1]) {
        const oneEndTime = sessionList[0].sessionDay + " " + sessionList[0].endTime;
        const twoStartTime = sessionList[1].sessionDay + " " + sessionList[1].startTime;
        // 若场次间有重叠，则分为 A/B 场
        if (this.$dayjs(oneEndTime).isAfter(twoStartTime, 'minute')) {
          const sessionListA = [], sessionListB = [];
          sessionList.forEach((s, i) => (i % 2 === 0 ? sessionListB.push(JSON.parse(JSON.stringify(s))) : sessionListA.push(JSON.parse(JSON.stringify(s)))));
          return {sessionListA, sessionListB};
        }
      }
      return false;
    },

    /* 根据场次状态返回展示信息 */
    getSessionInfo(session) {
      const {gameState, peopleNum = 0, playerMax = 0, tags} = session;
      const stateMap = {
        '-1': {text: '不可选', count: peopleNum},
        1: {text: '已预约', count: peopleNum},
        2: {text: '游戏中', count: peopleNum},
      };

      if (gameState === 0) {
        if (peopleNum >= playerMax || tags === 1) {
          return {text: '已满场', count: peopleNum};
        } else if (peopleNum > 0) {
          return {text: '可加入', count: playerMax - peopleNum};
        }
        return {text: '可预约', count: playerMax};
      }
      return stateMap[gameState] || {text: '未知', count: 0};
    },

    /* 格式化 session 数据以传给 itemDemo 组件 */
    formatSession(session) {
      const info = this.getSessionInfo(session);
      return {
        ...session,
        status: info.text,
        count: info.count,
        time: `${session.startTimeStr} - ${session.endTimeStr}`,
        style: {
          top: `${session.top}px`,
          left: '50%',
          transform: 'translateX(-50%)',
          position: 'absolute',
        },
        number: this.config.themeSort,
      };
    },

    /* 生成时间轴 */
    setTime() {
      const now = this.$dayjs();
      let baseTime = now.startOf('hour');
      if (now.minute() >= 30) baseTime = baseTime.add(30, 'minute');
      this.timeList = [{time: baseTime, timeStr: baseTime.format("HH:mm")}];

      for (let i = 1; i < this.rowsPerScreen; i++) {
        const prev = this.timeList[i - 1].time;
        this.timeList.push({
          time: prev.add(this.slotMinutes, 'minute'),
          timeStr: prev.add(this.slotMinutes, 'minute').format("HH:mm")
        });
      }
      this.visibleTimeSlots = this.timeList.map(item => item.timeStr);
    },

    //获取uuid
    getUUIDFromCurrentUrl() {
      try {
        // 处理hash中的参数（如你的示例URL）
        const hash = window.location.hash;
        if (hash.includes('?')) {
          const hashParams = new URLSearchParams(hash.split('?')[1]);
          return hashParams.get('uuid');
        }
        // 如果没有在hash中找到，尝试查询参数
        return new URLSearchParams(window.location.search).get('uuid');
      } catch (error) {
        console.error('解析URL出错:', error);
        return null;
      }
    },


  }
};
</script>


<style scoped>
.zhichi {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 200px;
  bottom: 10px;
  font-size: 16px;
  font-style: italic;
  margin-top: 4px;
  letter-spacing: 2px;
  color: #ffffff;
  background: rgba(60, 217, 229, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  z-index: 9999;
}
.timetable {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: white;
  position: relative;
}

.header-row {
  display: flex;
  width: 100%;
  background: #3CD9E5;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;

}

.header-cell {
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scene-cell {
  width: 120px;
  flex-shrink: 0;
}

.content-cell {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
.header-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.gantt-content {
  display: flex;
  flex: 1;
  overflow: hidden;
  margin-top: 15px;
  background: transparent;
}

/* 时间轴 */
.time-axis {
  width: 120px;
  flex-shrink: 0;
  background: #fff;
  border-right: 2px solid #e9ecef;
  position: sticky;
  left: 0;
  z-index: 5;
  margin-right: 10px;
}

.time-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: none;
  color: #000;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 28px;
}
.time-slot::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 3px;
  background: #F6F6F6;
  z-index: 2;
  pointer-events: none;
}

.time-label {
  z-index: 2;
  position: relative;
  background: #fff;
  padding: 0 8px;
}

.circle-outer {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  width: 17px;
  height: 17px;
  background: rgba(53, 227, 239, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
}

.circle-inner {
  width: 11px;
  height: 11px;
  background: #35e3ef;
  border-radius: 50%;
}

/* 主题内容区域 */
.themes-container {
  display: flex;
  flex: 1;
  min-width: 0;
  position: relative;
  background: #fff;
}

.theme-column {
  position: relative;
  flex-shrink: 0;
}

.time-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.grid-line {
  box-sizing: border-box;
}

.theme-column >>> .item-demo {
  z-index: 2;
  border-radius: 6px;
  margin: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  position: absolute;
  left: 2px;
  right: 2px;
}

.timetable-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  background-color: white;
  border: 2px solid #3CD9E5;
  border-radius: 12px;
  color: black;
  font-weight: bold;
  padding: 15px 20px;
  max-width: 600px;
  width: 100%;
  height: 100px;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
}
</style>
